import * as React from 'react';
import Radium from 'radium';
import { Button, ButtonToolbar, Col, Grid, Row } from 'react-bootstrap';

import ContactInformation from './../contact_information';
import Legal from './legal';
import NewsletterForm from './../newsletter_form';

@Radium
class Footer extends React.Component {
  render() {
    return (
      <Grid>
        <Row>
          <Col md={3} mdOffset={1}>
            <NewsletterForm />
            <h2 style={styles.h2}>Spojte se s námi!</h2>
            <ButtonToolbar style={styles.toolbar}>
              <Button bsStyle="facebook" href="https://www.facebook.com/studentizakum" target="_blank">
                <i className="fa fa-facebook-official">&nbsp;</i>
                Facebook
              </Button>
              <Button bsStyle="instagram" href="https://www.instagram.com/studentizakum/" target="_blank">
                <i className="fa fa-instagram">&nbsp;</i>
                Instagram
              </Button>
            </ButtonToolbar>
          </Col>
          <Col md={3} mdOffset={1} style={{ ...styles.white, ...styles.centered }}>
            <ContactInformation styles={styles} />
          </Col>
          <Col md={3} mdOffset={1} style={{ ...styles.white, ...styles.centered }}>
            <Legal />
          </Col>
        </Row>
        <div style={styles.copyright}>&copy; 2017-2021 Stužák</div>
      </Grid>
    );
  }
}

const styles = {
  h2: {
    color: '#FFF',
    fontSize: '16px'
  },
  h3: {
    fontSize: '14px',
    textTransform: 'uppercase'
  },
  copyright: {
    fontStyle: 'italic',
    color: '#FFF',
    fontSize: '12px',
    textAlign: 'center',
    marginTop: '30px'
  },
  toolbar: {
    margin: '0 auto',
    display: 'table'
  },
  centered: {
    textAlign: 'center'
  },
  white: {
    color: '#FFF'
  },
  link: {
    color: '#FFF',
    textDecoration: 'underline'
  }
};

export default Footer;



// WEBPACK FOOTER //
// ./src/browser/Feature/components/footer/index.jsx